import { isAxiosError } from "axios";

export const isDuplicateUserPhoneNumberError = (error: unknown) => {
  return (
    isAxiosError(error) &&
    error.response?.data?.title === "error.duplicateUserWithPhoneNumberExistsOnPlatform"
  );
};
